import { useState, useMemo } from 'react';
import { StatusBanca, TipoBancaNome, BancaUtils } from '../../../model/banca/Banca';
import { BancaNovaResponse } from '../../../model/banca/BancasNovaResponse';

export const useBancasFilter = (bancas: BancaNovaResponse[]) => {
  const [ocultarFinalizadas, setOcultarFinalizadas] = useState(false);
  const [sortedColumn, setSortedColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const sortBancas = (bancas: BancaNovaResponse[], column: string, direction: 'asc' | 'desc') => {
    return [...bancas].sort((a, b) => {
      let valueA, valueB;

      if (column === 'data') {
        const dateA = a.dataDeBanca?.data ? new Date(a.dataDeBanca.data).getTime() : null;
        const dateB = b.dataDeBanca?.data ? new Date(b.dataDeBanca.data).getTime() : null;

        if (dateA === null && dateB !== null) return 1;
        if (dateB === null && dateA !== null) return -1;
        if (dateA === null && dateB === null) return 0;

        valueA = dateA;
        valueB = dateB;
      } else if (column === 'tipoBanca') {
        const tipoOrdem: Record<TipoBancaNome, number> = {
          [TipoBancaNome.FACIAL]: 1,
          [TipoBancaNome.VIRTUAL]: 2,
          [TipoBancaNome.RECURSAL]: 3
        };
        valueA = tipoOrdem[a.tipoBanca?.nome as TipoBancaNome] || 0;
        valueB = tipoOrdem[b.tipoBanca?.nome as TipoBancaNome] || 0;
      } else if (column === 'status') {
        const statusOrdem = BancaUtils.getStatusArray();
        valueA = statusOrdem.indexOf(a.status);
        valueB = statusOrdem.indexOf(b.status);
      } else {
        valueA = a[column as keyof BancaNovaResponse];
        valueB = b[column as keyof BancaNovaResponse];
      }

      if (valueA != null && valueB != null) {
        if (valueA < valueB) return direction === 'asc' ? -1 : 1;
        if (valueA > valueB) return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  const handleSort = (column: string) => {
    const newDirection = sortedColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortedColumn(column);
    setSortDirection(newDirection);
  };

  const bancasProcessadas = useMemo(() => {
    const bancasFiltradas = bancas.filter(banca => {
      if (banca.status === StatusBanca.CANCELADA) return false;
      if (ocultarFinalizadas && banca.status === StatusBanca.FINALIZADA) return false;
      return true;
    });

    return sortedColumn 
      ? sortBancas(bancasFiltradas, sortedColumn, sortDirection)
      : bancasFiltradas;
  }, [bancas, ocultarFinalizadas, sortedColumn, sortDirection]);

  return {
    bancasProcessadas,
    ocultarFinalizadas,
    setOcultarFinalizadas,
    sortedColumn,
    sortDirection,
    handleSort
  };
};